export default __webpack_public_path__ + "static/media/coin1.d883e2cc.png";